import { Reveal, Overline } from "@/components/Reveal";
import { IMAGES } from "@/data";

const POINTS = [
  { k: "An energetic archive", v: "Often described as a living record of the soul — its intentions, experiences and the patterns it carries across time." },
  { k: "A lens, not a verdict", v: "A reading offers reflection and perspective, never prediction or diagnosis. You remain the author of your path." },
  { k: "Accessed with intention", v: "The Records are approached through prayer, stillness and respect — a sacred, contemplative practice held with care." },
];

export default function Akashic() {
  return (
    <section id="akashic" data-testid="akashic-section" className="section-pad py-24 md:py-36">
      <div className="max-w-3xl">
        <Overline>What Are Akashic Records?</Overline>
        <Reveal>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-6">
            An ancient idea, offered with modern sincerity.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="font-sans-ui text-[var(--muted-ink)] text-base md:text-lg leading-relaxed font-light mt-7">
            The Akashic Records are understood as an energetic library of the soul&rsquo;s journey. Within Brahmsara, a reading is offered purely as a contemplative practice — a gentle way to bring awareness to recurring themes and support healing, clarity and personal growth.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mt-16">
        {POINTS.map((p, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div className="h-full border-t border-[rgba(200,149,54,0.4)] pt-6 group">
              <span className="font-serif-display text-5xl text-[var(--gold)] block mb-4 transition-transform duration-500 group-hover:-translate-y-1">
                0{i + 1}
              </span>
              <h3 className="font-serif-display text-2xl mb-3">{p.k}</h3>
              <p className="font-sans-ui text-sm text-[var(--muted-ink)] leading-relaxed font-light">{p.v}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="relative overflow-hidden mt-20 grain">
          <img src={IMAGES.nature} alt="Calm sunset reflection over water" className="w-full h-[300px] md:h-[440px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[rgba(26,26,26,0.35)] to-transparent" />
          <p className="absolute bottom-8 left-8 right-8 font-serif-display italic text-2xl md:text-4xl text-white max-w-3xl leading-snug">
            &ldquo;Greater awareness of our patterns is where healing quietly begins.&rdquo;
          </p>
        </div>
      </Reveal>
    </section>
  );
}
